import React from 'react';

import PropTypes from 'prop-types';

import {
  Formik, Form as FormikForm,
} from 'formik';

import {
  SelectFieldV2,
  SubmitButton,
} from 'ui/FormElement';

import useAvatars from 'components/Admin/Avatars/Hooks/useAvatars';

import actions from './Actions';

export default function Form({ enterpriseId, avatarId }) {
  const { avatars } = useAvatars();

  const onSubmit = (values, { setSubmitting }) => {
    actions.saveAvatar(enterpriseId, values, () => {
      setSubmitting(false);
      swal('AI Coach Saved');
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        avatar: avatarId,
      }}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">

          <SelectFieldV2
            name="avatar"
            isClearable
            placeholder={
              avatars == null
                ? 'AI Coaches is loading ...'
                : 'Choose AI Coach...'
            }
            options={avatars !== null ? avatars.map((item) => ({
              label: item.attributes.name,
              value: parseInt(item.id, 10),
            })) : []}
          />
          <div className="text-right">
            <SubmitButton
              title={isSubmitting ? 'Please, wait ...' : 'Save'}
              className={`btn width-120 btn-primary submit-button mr5 ml5 ${
                isSubmitting ? 'not-possible-click' : ''
              }`}
            />
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}

Form.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  avatarId: PropTypes.number,
};

Form.defaultProps = {
  avatarId: null,
};
